import { Modal } from 'antd';
import React from 'react';
import styles from './waypoint_delete_modal.less';
import { Waypoint } from '@omniafishing/core';

interface WaypointDeleteModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  waypoint: Waypoint;
  onWaypointDelete: (waypointId: number) => void;
}

export const WaypointDeleteModal = (props: WaypointDeleteModalProps) => {
  const { isOpen, onOpenChange, waypoint, onWaypointDelete } = props;
  return (
    <Modal
      title="Delete Waypoint"
      centered
      closable
      open={isOpen}
      onOk={(e) => {
        e.stopPropagation();
        onWaypointDelete(waypoint.id);
        onOpenChange(false);
      }}
      onCancel={(e) => {
        e.stopPropagation();
        onOpenChange(false);
      }}
      wrapClassName={styles.antModal}
      width={'375px'}
    >
      Are you sure you want to delete your waypoint?
    </Modal>
  );
};
